import { render, staticRenderFns } from "./EmotionDetailContrast.vue?vue&type=template&id=35964301&scoped=true&"
import script from "./EmotionDetailContrast.vue?vue&type=script&lang=js&"
export * from "./EmotionDetailContrast.vue?vue&type=script&lang=js&"
import style0 from "./EmotionDetailContrast.vue?vue&type=style&index=0&media=print&lang=css&"
import style1 from "./EmotionDetailContrast.vue?vue&type=style&index=1&id=35964301&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35964301",
  null
  
)

export default component.exports